<template>
  <div class="py-5 container-fluid">
    <div id="topinfo">
      <div class="row mt-4 justify-content-center">
        <div class="col-12">
          <div class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex mb-2 flex-column card card-body blur shadow-blur">
            <div class="card-header mb-0 text-center">
              <h3 class="font-weight-bolder text-success text-gradient">
                Reset Recipe {{ original_recipe_name ? `"${original_recipe_name}"` : "" }}
              </h3>
              <h5
                v-if="coating_booth"
                class="mb-0"
              >
                for Line <i>{{ coating_booth.name }}</i>
              </h5>
            </div>
          </div>
          <div class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex flex-column card card-body blur shadow-blur">
            <div class="row mx-4">
              <div class="col-md-8">
                <h6>Recipe Name</h6>
                <input
                  v-model="recipe.category"
                  type="text"
                  class="form-control mt-2 mb-2"
                  :class="showRecipeNameError ? 'is-invalid' : ''"
                  placeholder="Enter Recipe Name"
                  @blur="validateRecipeName()"
                  style="width: 90%"
                />
                <label
                  v-if="showRecipeNameError"
                  class="text-danger"
                  style="font-size: 0.8rem"
                >
                  Required field
                </label>
              </div>
              <div class="col-md-4">
                <h6
                  class="mb-2"
                  style="font-size: 1rem"
                >
                  Hopper
                </h6>
                <span
                  class="text-muted"
                  v-if="hopper"
                  style="font-size: 0.95rem"
                  >{{ hopper.name }}</span
                >
              </div>
            </div>
            <div
              v-if="hopper !== null"
              class="card-header row py-1"
            >
              <div class="card-body py-1">
                <div class="table-responsive">
                  <h6>Side Reciprocators</h6>
                  <table class="table text-center table-sm">
                    <thead>
                      <tr>
                        <th class="small">Gun Name</th>
                        <th class="small">Powder Amount</th>
                        <th class="small">Gun Offset [%]</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="gun in gun_data.filter(gun => gun.is_gun_on_bottom_reciprocator === false)"
                        :key="gun.gun_id"
                      >
                        <td class="small">
                          {{ gun.gun_name }}
                        </td>
                        <td class="small">
                          <span>
                            <input
                              v-model="gun.powder_amount_setting"
                              class="table-input-cell form-control form-control-sm mx-auto text-center"
                              type="number"
                              :placeholder="'Powder Amount'"
                              :step="0.1"
                              @blur="validatePowderAmountSetting(gun)"
                              @input="
                                floorPowderAmountSettingToOneDecimal(gun);
                                clearTargetThroughput(gun);
                              "
                            />
                          </span>
                        </td>
                        <td class="small">
                          <span>
                            <input
                              v-model="gun.throughput_offset"
                              class="table-input-cell form-control form-control-sm mx-auto text-center"
                              type="number"
                              min="-100"
                              max="100"
                              step="1"
                              :placeholder="'Gun offset [%]'"
                              @input="
                                floorGunThroughputOffsetToInteger(gun);
                                clearTargetThroughput(gun);
                              "
                              @blur="validateGunOffset(gun)"
                            />
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="compute-section">
                    <soft-button
                      type="button"
                      :disabled="sideComputeDisabled"
                      :variant="sideComputeDisabled ? 'outline' : 'gradient'"
                      @click="computeTargetThroughput()"
                    >
                      {{
                        sideComputeDisabled
                          ? "Fill Powder Amounts to Compute Target Throughput"
                          : "Compute Target Throughput"
                      }}
                    </soft-button>
                    <MiniStatisticsCard
                      v-if="sideThroughputComputed"
                      title="Target throughput"
                      :value="`${recipe.target_throughput.toFixed(1)}`"
                      percentage=""
                      :icon="{ component: 'ni ni ni-support-16', background: 'bg-gradient-info' }"
                      class-content="px-2  "
                    />
                  </div>
                </div>
                <div v-if="coating_booth.reciprocator_side_bottom">
                  <h6 class="mt-4">Bottom Reciprocator</h6>
                  <div class="row mb-2"></div>
                  <div class="table-responsive">
                    <table class="table text-center table-sm">
                      <thead>
                        <tr>
                          <th class="small">Gun Name</th>
                          <th class="small">Powder Amount</th>
                          <th class="small">Gun Offset [%]</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="gun in gun_data.filter(gun => gun.is_gun_on_bottom_reciprocator === true)"
                          :key="gun.gun_id"
                        >
                          <td class="small">
                            {{ gun.gun_name }}
                          </td>
                          <td class="small">
                            <span>
                              <input
                                v-model="gun.powder_amount_setting"
                                class="table-input-cell form-control form-control-sm mx-auto text-center"
                                type="number"
                                :placeholder="'Powder amount setting'"
                                @input="
                                  floorPowderAmountSettingToOneDecimal(gun);
                                  clearTargetThroughput(gun);
                                "
                              />
                            </span>
                          </td>
                          <td class="small">
                            <span>
                              <input
                                v-model="gun.throughput_offset"
                                class="table-input-cell form-control form-control-sm mx-auto text-center"
                                type="number"
                                min="-100"
                                max="100"
                                step="1"
                                :placeholder="'Gun offset percentage [%]'"
                                @input="
                                  floorGunThroughputOffsetToInteger(gun);
                                  clearTargetThroughput(gun);
                                "
                                @blur="validateGunOffset(gun)"
                              />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="compute-section">
                      <soft-button
                        type="button"
                        :disabled="bottomComputeDisabled"
                        :variant="bottomComputeDisabled ? 'outline' : 'gradient'"
                        @click="computeTargetThroughputBottom()"
                      >
                        {{
                          bottomComputeDisabled
                            ? "Fill Powder Amounts to Compute Bottom Target Throughput"
                            : "Compute Bottom Target Throughput"
                        }}
                      </soft-button>
                      <MiniStatisticsCard
                        v-if="bottomThroughputComputed"
                        title="Target throughput bottom"
                        :value="`${recipe.target_throughput_bottom.toFixed(1)}`"
                        percentage=""
                        :icon="{ component: 'ni ni ni-support-16', background: 'bg-gradient-info' }"
                        class-content="px-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-row mt-4">
                <soft-button
                  type="button"
                  color="secondary"
                  variant="gradient"
                  class="mb-0 me-2 js-btn-next"
                  style="min-width: 160px; max-width: 500px"
                  @click="
                    $router.push({
                      name: 'SteelCaseDashboard',
                      params: {
                        lineId: coating_booth.id,
                      },
                    })
                  "
                >
                  Go Back &nbsp; &nbsp;
                </soft-button>
                <soft-button
                  type="button"
                  class="mb-0 w-100"
                  style="min-width: 200px"
                  :disabled="saveButtonDisabled"
                  :variant="saveButtonDisabled ? 'outline' : 'gradient'"
                  @click="saveRecipeSettings()"
                >
                  Save Recipe Settings
                </soft-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import setTooltip from "@/assets/js/tooltip.js";
import SoftButton from "@/components/SoftButton.vue";
import MiniStatisticsCard from "@/components/MiniStatisticsCard.vue";
import { isNumber } from "lodash";

export default {
  name: "ResetRecipe",
  components: {
    SoftButton,
    MiniStatisticsCard,
  },
  props: {
    lineId: {
      type: String,
      default: "",
    },
    hopperId: {
      type: String,
      default: "",
    },
    recipeId: {
      type: String,
      default: "",
    },
  },
  data() {
    this.$i18n.locale = this.$store.state.user_data.language;

    return {
      original_recipe_name: null,
      coating_booth: {},
      hopper: null,
      recipe: {
        category: "",
        target_throughput: null,
        target_throughput_bottom: null,
      },
      gun_data: [],
      isRecipeNameValid: null,
    };
  },
  computed: {
    throughputsComputed() {
      if (this.coating_booth.reciprocator_side_bottom) {
        return this.recipe.target_throughput !== null && this.recipe.target_throughput_bottom !== null;
      } else {
        return this.recipe.target_throughput !== null;
      }
    },
    sideThroughputComputed() {
      return this.recipe.target_throughput !== null;
    },
    bottomThroughputComputed() {
      return this.recipe.target_throughput_bottom !== null;
    },
    bottomComputeDisabled() {
      if (!this.coating_booth.reciprocator_side_bottom) {
        return false;
      }
      const bottomGuns = this.gun_data.filter(gun => gun.is_gun_on_bottom_reciprocator === true);
      return bottomGuns.some(gun => !gun.powder_amount_setting);
    },
    sideComputeDisabled() {
      const sideGuns = this.gun_data.filter(gun => gun.is_gun_on_bottom_reciprocator === false);
      return sideGuns.some(gun => !gun.powder_amount_setting);
    },
    saveButtonDisabled() {
      return this.throughputsComputed === false || this.recipe.category === "";
    },
    showRecipeNameError() {
      return (this.recipe.category === "" && this.throughputsComputed) || this.isRecipeNameValid === false;
    },
  },
  mounted() {
    this.$store.state.isAbsolute = true;
    setTooltip();
    this.getData();
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
  },
  methods: {
    async getData() {
      await Promise.all([this.getCoatingBooth(), this.getRecipe(), this.getHopper()]);
      this.gun_data = await this.getGunData();
      this.autofillGunOffsets();
      this.autoFillInitialPowderAmountSettings();
    },
    async getCoatingBooth() {
      try {
        const response = await axios.get("api/v1/steelcase/coatingbooth/" + this.lineId + "/");
        this.coating_booth = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async getRecipe() {
      try {
        let response = await axios.get(`api/v1/steelcase/recipe/${this.recipeId}/`);
        response.data.target_throughput = null;
        response.data.target_throughput_bottom = null;
        this.recipe = response.data;
        this.original_recipe_name = this.recipe.category;
        console.log("Recipe data:", this.recipe);
      } catch (error) {
        console.error(error);
      }
    },
    async getHopper() {
      try {
        const response = await axios.get(`api/v1/steelcase/hopper/${this.hopperId}/`);
        this.hopper = response.data;
        console.log("Hopper data:", this.hopper);
      } catch (error) {
        console.error(error);
      }
    },
    autofillGunOffsets() {
      // Auto-fill form with recipe.target_throughput_offsets if available
      if (
        this.recipe === null ||
        this.recipe.target_throughput_offsets === undefined ||
        this.recipe.target_throughput_offsets === null ||
        !Array.isArray(this.recipe.target_throughput_offsets) ||
        this.recipe.target_throughput_offsets.length === 0
      ) {
        console.log("No Target Throughput Offsets defined for this recipe.");
        return;
      }
      this.recipe.target_throughput_offsets.forEach(offset => {
        let gun = this.gun_data.find(gun => gun.id == offset.gun);
        if (gun) {
          gun.throughput_offset = parseFloat(parseFloat((offset.offset - 1) * 100).toFixed(0));
        }
      });
    },
    autoFillInitialPowderAmountSettings() {
      // Auto-fill form with initial powder amount settings if available
      if (
        this.recipe === null ||
        this.recipe.initial_powder_amount_settings === undefined ||
        this.recipe.initial_powder_amount_settings === null ||
        !Array.isArray(this.recipe.initial_powder_amount_settings) ||
        this.recipe.initial_powder_amount_settings.length === 0
      ) {
        this.$swal({
          title: `No Initial Powder Amount Settings defined for recipe "${this.original_recipe_name}"`,
          text: "Provide Initial Powder Amount Settings manually to proceed with the Recipe reset.",
          icon: "info",
          confirmButtonText: "OK",
        });
        return;
      }

      this.recipe.initial_powder_amount_settings.forEach(setting => {
        let gun = this.gun_data.find(gun => gun.id == setting.gun);
        if (gun) {
          gun.powder_amount_setting = Math.floor(setting.amount * 10) / 10;
        }
      });
    },
    validateRecipeName() {
      if (this.recipe.category.trim() === "") {
        this.isRecipeNameValid = false;
      } else {
        this.isRecipeNameValid = true;
      }
    },
    validatePowderAmountSetting(gun) {
      const setting = gun.powder_amount_setting;
      if (
        isNumber(setting) === true &&
        (setting < this.coating_booth.min_powder_amount_setting ||
          setting > this.coating_booth.max_powder_amount_setting)
      ) {
        gun.powder_amount_setting = null;
        this.$swal({
          title: "Invalid Powder Amount Setting",
          text: `Powder Amount Setting must be between ${this.coating_booth.min_powder_amount_setting} and ${this.coating_booth.max_powder_amount_setting}.`,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    },
    validateGunOffset(gun) {
      const offset = gun.throughput_offset;
      if (offset < -100 || offset > 100) {
        gun.throughput_offset = 0;
        this.$swal({
          title: "Invalid Gun Offset",
          text: "Gun Offset must be between -100% and 100%.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
      if (isNaN(offset) || offset === null || offset === undefined || offset === "") {
        gun.throughput_offset = 0;
      }
    },
    clearTargetThroughput(gun) {
      if (gun.is_gun_on_bottom_reciprocator && this.recipe.target_throughput_bottom !== null) {
        this.recipe.target_throughput_bottom = null;
      }
      if (!gun.is_gun_on_bottom_reciprocator && this.recipe.target_throughput !== null) {
        this.recipe.target_throughput = null;
      }
    },
    floorGunThroughputOffsetToInteger(gun) {
      if (typeof gun.throughput_offset === "number") {
        gun.throughput_offset = Math.floor(gun.throughput_offset);
      }
    },
    floorPowderAmountSettingToOneDecimal(gun) {
      if (typeof gun.powder_amount_setting === "number") {
        gun.powder_amount_setting = Math.floor(gun.powder_amount_setting * 10) / 10;
      }
    },
    enrichGunData(gunData) {
      const gun = { ...gunData };
      gun.gun_id = gunData.id;
      gun.gun_name = gunData.name;
      gun.throughput_offset = null;
      gun.powder_amount_setting = null;

      return gun;
    },
    async getGunData() {
      try {
        const reponse = await axios.get(`api/v1/steelcase/guns/coating-booth/${this.coating_booth.id}/`);
        const guns = reponse.data;
        const enriched_guns = guns.map(gun => this.enrichGunData(gun));
        return enriched_guns.sort((a, b) => a.gun_index - b.gun_index);
      } catch (error) {
        console.error(error);
      }
    },
    prepareGunData(gun) {
      return {
        gun_id: gun.gun_id,
        powder_amount_setting: gun.powder_amount_setting,
        throughput_offset: gun.throughput_offset,
      };
    },
    async computeTargetThroughput() {
      const gun_data = this.gun_data
        .filter(gun => gun.is_gun_on_bottom_reciprocator === false)
        .map(gun => this.prepareGunData(gun));
      const response = await axios.post("api/v1/steelcase/computethroughputfrompowderamountsettings/", {
        gun_data: gun_data,
      });

      this.recipe.target_throughput = response.data.target_throughput;
    },
    async computeTargetThroughputBottom() {
      const gun_data = this.gun_data
        .filter(gun => gun.is_gun_on_bottom_reciprocator === true)
        .map(gun => this.prepareGunData(gun));
      const response = await axios.post("api/v1/steelcase/computethroughputfrompowderamountsettings/", {
        gun_data: gun_data,
      });

      this.recipe.target_throughput_bottom = response.data.target_throughput;
    },
    async calculateEqualizedPowderAmounts(recipeId) {
      const response = await axios.post("api/v1/steelcase/computerecipepowderamountsettingsfromtargetthroughput/", {
        recipe_id: recipeId,
        target_throughput: this.recipe.target_throughput,
        target_throughput_bottom: this.recipe.target_throughput_bottom,
      });
      const { powder_amount_settings_by_gun_index, gun_output_data } = response.data || {};

      if (!powder_amount_settings_by_gun_index || !gun_output_data) {
        throw new Error("Missing required fields in API response.");
      }

      return { powder_amount_settings_by_gun_index, gun_output_data };
    },
    async updateRecipeTargetThroughputs(recipeId) {
      let body = {
        target_throughput: this.recipe.target_throughput,
      };

      if (
        this.recipe.target_throughput_bottom != null &&
        this.recipe.target_throughput_bottom != undefined &&
        isNumber(this.recipe.target_throughput_bottom)
      ) {
        body.target_throughput_bottom = this.recipe.target_throughput_bottom;
      }

      await axios.patch(`api/v1/steelcase/recipe/${recipeId}/`, body);
    },
    async createPowderAmountSettings(recipeId, powder_amount_settings_by_gun_index) {
      const powderAmountSettingsPerGun = this.gun_data
        .map(gun => ({
          gun_id: gun.gun_id,
          powder_amount_setting: powder_amount_settings_by_gun_index[gun.gun_index].new_powder_amount_setting,
        }))
        .filter(setting => setting.powder_amount_setting !== null && setting.powder_amount_setting !== undefined);

      await axios.post("api/v1/steelcase/createpowderamountsettingsbyrecipe/", {
        recipe_id: recipeId,
        powder_amount_settings_per_gun: powderAmountSettingsPerGun,
      });
    },
    async upsertInitialPowderAmountSettings(recipeId) {
      const initialPowderAmountSettingsPerGun = this.gun_data
        .map(gun => ({
          gun_id: gun.gun_id,
          powder_amount_setting: gun.powder_amount_setting,
        }))
        .filter(setting => setting.powder_amount_setting !== null && setting.powder_amount_setting !== undefined);

      await axios.post("api/v1/steelcase/upsert-initial-powder-amount-settings-by-recipe/", {
        recipe_id: recipeId,
        initial_powder_amount_settings_per_gun: initialPowderAmountSettingsPerGun,
      });
    },
    async storeInferredGunCoefficientsAndStatus(recipeId, powder_amount_settings_by_gun_index, gun_output_data) {
      const diagnosisPerGun = {};
      this.gun_data.forEach(gun => {
        diagnosisPerGun[gun.gun_identifier] = powder_amount_settings_by_gun_index[gun.gun_index].diagnosis;
      });
      await axios.post("api/v1/steelcase/bulkupdateinferredcoefficientsandstatus/", {
        hopper_id: this.hopper.id,
        gun_output_data: gun_output_data,
        diagnosis_per_recipe: { [recipeId]: diagnosisPerGun },
      });
    },
    async updateThroughputOffsets(recipeId) {
      const offsetsByGunIdData = {};
      this.gun_data.forEach(gun => {
        offsetsByGunIdData[gun.gun_id] = 1 + parseFloat(gun.throughput_offset) / 100;
      });

      await axios.post("api/v1/steelcase/target-throughput-offset/bulk-create-update/ ", {
        recipe_id: recipeId,
        offsets_by_gun_id: offsetsByGunIdData,
      });
    },
    async saveRecipeSettings() {
      try {
        await this.updateThroughputOffsets(this.recipe.id);

        const { powder_amount_settings_by_gun_index, gun_output_data } = await this.calculateEqualizedPowderAmounts(
          this.recipe.id,
        );

        await Promise.all([
          this.updateRecipeTargetThroughputs(this.recipe.id),
          this.createPowderAmountSettings(this.recipe.id, powder_amount_settings_by_gun_index),
          this.upsertInitialPowderAmountSettings(this.recipe.id),
          this.storeInferredGunCoefficientsAndStatus(
            this.recipe.id,
            powder_amount_settings_by_gun_index,
            gun_output_data,
          ),
        ]);

        this.$swal({
          title: "Success",
          text: `Recipe "${this.recipe.category}" saved successfully for hopper "${this.hopper.name}".`,
          icon: "success",
          confirmButtonText: "Ok",
        }).then(result => {
          if (result.isConfirmed) {
            this.$router.push({
              name: "SteelCaseDashboard",
              params: {
                lineId: this.lineId,
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
        this.$swal({
          title: "Error",
          text: `An error occurred while saving the recipe: ${error.message}`,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    },
    clearData() {
      this.recipe = {
        category: "",
        target_throughput: null,
        target_throughput_bottom: null,
      };
      this.gun_data = this.gun_data.map(gun => {
        gun.powder_amount_setting = null;
        gun.throughput_offset = null;
        return gun;
      });
    },
  },
};
</script>
<style scoped>
.table-sm th,
.table-sm td {
  padding: 0.3rem;
  height: 2.2rem;
  vertical-align: middle;
}

.table thead th {
  text-transform: none;
}

.table-input-cell {
  width: 60%;
  padding: 0.75rem;
  height: 1.6rem;
  text-align: center;
  box-sizing: border-box;
  vertical-align: middle;
  background-color: transparent;
  border: 1px solid #a7a7a7; /* lighter gray */
}
.container-fluid {
  padding-top: 20px;
}

.compute-section {
  display: flex;
  gap: 15px;
  align-items: center;
  justify-content: flex-start;
}

.compute-section > * {
  width: 50%;
}
</style>
